import React from 'react';
import { ArrowRightIcon, PlayIcon, CalendarIcon, MusicIcon, ImageIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSpotify } from './SpotifyContext';
const Home = () => {
  const {
    openSpotifyPlayer
  } = useSpotify();
  // Function to scroll to top when navigating
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return <div className="pt-0 space-y-16" data-id="element-250">
      {/* Hero Section */}
      <section className="relative" data-id="element-251">
        <div className="absolute -inset-1 bg-gradient-to-r from-pink-500/20 to-purple-500/20 rounded-2xl blur-lg" data-id="element-252"></div>
        <div className="relative overflow-hidden rounded-2xl" data-id="element-253">
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/40 z-10" data-id="element-254"></div>
          <img src="https://fabricreality.com/wp-content/uploads/2022/09/Photo33.jpg" alt="Fabric Reality" className="w-full h-[60vh] sm:h-[70vh] md:h-[80vh] object-cover object-center" data-id="element-255" />
          <div className="absolute inset-0 z-20 flex flex-col justify-center p-6 md:p-12" data-id="element-256">
            <h1 className="text-5xl sm:text-6xl md:text-7xl font-bold mb-4 text-white drop-shadow-lg font-mono" data-id="element-257">
              FABRIC{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400" data-id="element-258">
                REALITY
              </span>
            </h1>
            <p className="text-xl sm:text-2xl md:text-3xl text-gray-100 max-w-2xl mb-8 drop-shadow-md" data-id="element-259">
              Explore the cosmic universe of interstellar rock music
            </p>
            <div className="flex flex-wrap gap-4" data-id="element-260">
              <Link to="/universe" className="px-6 py-3 bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-500 hover:to-purple-500 text-white font-bold rounded-lg transition-all duration-300 hover:shadow-lg hover:shadow-pink-500/30 flex items-center" onClick={scrollToTop} data-id="element-261">
                EXPLORE UNIVERSE
                <ArrowRightIcon size={18} className="ml-2" data-id="element-262" />
              </Link>
              <button onClick={openSpotifyPlayer} className="px-6 py-3 bg-black/50 backdrop-blur-sm border border-pink-500/30 hover:bg-black/70 text-white font-bold rounded-lg transition-all duration-300 flex items-center" type="button" data-id="element-263">
                <PlayIcon size={18} className="mr-2" data-id="element-264" />
                LISTEN NOW
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Brief Bio Section */}
      <section className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-265">
        <div data-id="element-266">
          <h2 className="text-4xl font-bold mb-6 font-mono text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400 inline-block" data-id="element-267">
            WHO WE ARE
          </h2>
          <div className="space-y-4 text-gray-200" data-id="element-268">
            <p className="text-lg" data-id="element-269">
              Fabric Reality is the music project of Garbs, a
              Singer/Songwriter/Producer of Irish descent and
              Producer/Songwriter/Creator Russell James Williams.
            </p>
            <p className="text-lg" data-id="element-270">
              With heavily styled synth-based landscapes infused with guitars,
              we wrap dynamic song structures and infectious melodies into a
              spectacular sound that creates a new moment for the Alternative
              genre.
            </p>
            <div className="mt-6" data-id="element-271">
              <Link to="/biography" className="inline-flex items-center text-pink-400 hover:text-pink-300 transition-colors" onClick={scrollToTop} data-id="element-272">
                <span className="mr-2" data-id="element-273">READ OUR FULL STORY</span>
                <ArrowRightIcon size={16} data-id="element-274" />
              </Link>
            </div>
          </div>
        </div>
        <div className="relative" data-id="element-275">
          <div className="absolute -inset-1 bg-gradient-to-r from-purple-500/30 to-pink-500/30 rounded-xl blur" data-id="element-276"></div>
          <img src="https://fabricreality.com/wp-content/uploads/2022/09/Photo49.jpg" alt="Fabric Reality performance" className="relative rounded-xl w-full aspect-square object-cover" data-id="element-277" />
        </div>
      </section>

      {/* Latest Release */}
      <section className="relative" data-id="element-278">
        <div className="absolute -inset-1 bg-gradient-to-r from-purple-500/20 to-pink-500/20 rounded-2xl blur-lg" data-id="element-279"></div>
        <div className="relative bg-black/60 backdrop-blur-md p-8 rounded-2xl border border-purple-500/20 shadow-xl" data-id="element-280">
          <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-281">
            <div className="md:w-1/3 relative" data-id="element-282">
              <div className="absolute -inset-1 bg-gradient-to-r from-pink-500/30 to-purple-500/30 rounded-xl blur" data-id="element-283"></div>
              <img src="https://fabricreality.com/wp-content/uploads/2022/09/NEW-EXHIBITION-1-e1648686271558.png" alt="Latest Release" className="relative rounded-xl w-full aspect-square object-cover" data-id="element-284" />
            </div>
            <div className="md:w-2/3" data-id="element-285">
              <h2 className="text-4xl font-bold mb-4 font-mono text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400 inline-block" data-id="element-286">
                LATEST RELEASE
              </h2>
              <h3 className="text-2xl font-semibold text-white mb-3" data-id="element-287">
                "Exhibition" - Fabric Reality EP
              </h3>
              <p className="text-lg text-gray-300 mb-6" data-id="element-288">
                Our debut EP features the singles 'Exhibition', 'How It Feels To
                Love You Lately' and 'Sunset On Saturn.' Experience our
                signature interstellar sound through this collection of tracks
                that takes you on a journey through space while keeping you
                grounded in emotion.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-289">
                <button onClick={openSpotifyPlayer} className="px-6 py-3 bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-500 hover:to-purple-500 text-white font-bold rounded-lg transition-all duration-300 hover:shadow-lg hover:shadow-pink-500/30 flex items-center" type="button" data-id="element-290">
                  <MusicIcon size={18} className="mr-2" data-id="element-291" />
                  LISTEN NOW
                </button>
                <Link to="/lyrics" className="px-6 py-3 bg-black/50 backdrop-blur-sm border border-pink-500/30 hover:bg-black/70 text-white font-bold rounded-lg transition-all duration-300 flex items-center" onClick={scrollToTop} data-id="element-292">
                  VIEW LYRICS
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Sections */}
      <section data-id="element-293">
        <h2 className="text-4xl font-bold mb-8 font-mono text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400 inline-block" data-id="element-294">
          EXPLORE OUR UNIVERSE
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-295">
          {/* Visualizers Card */}
          <Link to="/visualisers" className="group relative overflow-hidden rounded-xl bg-black/40 border border-purple-500/20 hover:border-purple-500/40 transition-all duration-300 hover:shadow-lg hover:shadow-purple-500/20 h-[280px]" onClick={scrollToTop} data-id="element-296">
            <div className="absolute inset-0 overflow-hidden" data-id="element-297">
              <img src="https://fabricreality.com/wp-content/uploads/2022/09/Screenshot-2022-03-27-at-13.10.17.png" alt="Visualizers" className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-110" data-id="element-298" />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent" data-id="element-299"></div>
            </div>
            <div className="absolute inset-0 flex flex-col justify-end p-6 z-10" data-id="element-300">
              <div className="mb-4 w-12 h-12 rounded-full bg-pink-600/90 flex items-center justify-center" data-id="element-301">
                <PlayIcon size={24} className="text-white" data-id="element-302" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-303">
                Visualizers
              </h3>
              <p className="text-gray-300 mb-4" data-id="element-304">
                Experience our music through stunning visual journeys
              </p>
              <span className="text-pink-400 flex items-center text-sm group-hover:translate-x-1 transition-transform" data-id="element-305">
                WATCH NOW <ArrowRightIcon size={14} className="ml-1" data-id="element-306" />
              </span>
            </div>
          </Link>
          {/* Live Shows Card */}
          <Link to="/live" className="group relative overflow-hidden rounded-xl bg-black/40 border border-purple-500/20 hover:border-purple-500/40 transition-all duration-300 hover:shadow-lg hover:shadow-purple-500/20 h-[280px]" onClick={scrollToTop} data-id="element-307">
            <div className="absolute inset-0 overflow-hidden" data-id="element-308">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ps3k5nidS8uq9sbbp91Kye/1659642841402_filtered.jpg" alt="Live Shows" className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-110" data-id="element-309" />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent" data-id="element-310"></div>
            </div>
            <div className="absolute inset-0 flex flex-col justify-end p-6 z-10" data-id="element-311">
              <div className="mb-4 w-12 h-12 rounded-full bg-purple-600/90 flex items-center justify-center" data-id="element-312">
                <CalendarIcon size={24} className="text-white" data-id="element-313" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-314">Live Shows</h3>
              <p className="text-gray-300 mb-4" data-id="element-315">
                Join us for an immersive live experience
              </p>
              <span className="text-pink-400 flex items-center text-sm group-hover:translate-x-1 transition-transform" data-id="element-316">
                VIEW DATES <ArrowRightIcon size={14} className="ml-1" data-id="element-317" />
              </span>
            </div>
          </Link>
          {/* Universe Explorer Card */}
          <Link to="/universe" className="group relative overflow-hidden rounded-xl bg-black/40 border border-purple-500/20 hover:border-purple-500/40 transition-all duration-300 hover:shadow-lg hover:shadow-purple-500/20 h-[280px]" onClick={scrollToTop} data-id="element-318">
            <div className="absolute inset-0 overflow-hidden" data-id="element-319">
              <img src="https://fabricreality.com/wp-content/uploads/2022/09/Photo23_23-2.jpg" alt="Universe Explorer" className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-110" data-id="element-320" />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent" data-id="element-321"></div>
            </div>
            <div className="absolute inset-0 flex flex-col justify-end p-6 z-10" data-id="element-322">
              <div className="mb-4 w-12 h-12 rounded-full bg-indigo-600/90 flex items-center justify-center" data-id="element-323">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-white" data-id="element-324">
                  <circle cx="12" cy="12" r="10" data-id="element-325"></circle>
                  <circle cx="12" cy="12" r="4" data-id="element-326"></circle>
                  <line x1="4.93" y1="4.93" x2="9.17" y2="9.17" data-id="element-327"></line>
                  <line x1="14.83" y1="14.83" x2="19.07" y2="19.07" data-id="element-328"></line>
                  <line x1="14.83" y1="9.17" x2="19.07" y2="4.93" data-id="element-329"></line>
                  <line x1="14.83" y1="9.17" x2="18.36" y2="5.64" data-id="element-330"></line>
                  <line x1="4.93" y1="19.07" x2="9.17" y2="14.83" data-id="element-331"></line>
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-332">
                Universe Explorer
              </h3>
              <p className="text-gray-300 mb-4" data-id="element-333">
                Navigate through our cosmic musical universe
              </p>
              <span className="text-pink-400 flex items-center text-sm group-hover:translate-x-1 transition-transform" data-id="element-334">
                EXPLORE NOW <ArrowRightIcon size={14} className="ml-1" data-id="element-335" />
              </span>
            </div>
          </Link>
        </div>
      </section>

      {/* Photo Gallery Preview */}
      <section data-id="element-336">
        <div className="flex justify-between items-end mb-6" data-id="element-337">
          <h2 className="text-4xl font-bold font-mono text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400 inline-block" data-id="element-338">
            GALLERY
          </h2>
          <Link to="/images" className="text-pink-400 hover:text-pink-300 transition-colors flex items-center" onClick={scrollToTop} data-id="element-339">
            VIEW ALL <ArrowRightIcon size={16} className="ml-1" data-id="element-340" />
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4" data-id="element-341">
          {['https://fabricreality.com/wp-content/uploads/2022/09/Photo49.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/aoNiK6X7s9SwvUUd4f5yBG/1659642876701_filtered.jpg', 'https://fabricreality.com/wp-content/uploads/2022/09/Photo24_21.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/rfd1JqkjnJPrxrGGi1bcdH/1659642927638_filtered.jpg'].map((img, index) => <Link key={index} to="/images" className="relative aspect-square overflow-hidden rounded-lg group" onClick={scrollToTop} data-id="element-342">
              <img src={img} alt={`Gallery image ${index + 1}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-343" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center" data-id="element-344">
                <div className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center transform scale-0 group-hover:scale-100 transition-transform duration-300" data-id="element-345">
                  <ImageIcon size={20} className="text-white" data-id="element-346" />
                </div>
              </div>
            </Link>)}
        </div>
      </section>

      {/* Quote */}
      <section className="p-8 bg-gradient-to-r from-pink-900/20 to-purple-900/20 rounded-xl border border-pink-500/10" data-id="element-347">
        <blockquote className="italic text-xl md:text-2xl text-center text-gray-300" data-id="element-348">
          "We wanted to create something that felt both familiar and completely
          new - music that takes you on a journey through space while keeping
          you grounded in emotion."
          <footer className="mt-4 text-right text-pink-300 font-semibold" data-id="element-349">
            — Garbs, Fabric Reality
          </footer>
        </blockquote>
      </section>
    </div>;
};
export default Home;